/* eslint-disable max-len */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { LoadingSpinner, pitchTypeDisplayName } from 'yankees-react-utils';
import { Form } from 'react-bootstrap';
import StrikeZone from '../../../../components/StrikeZone';
import ReportCard from '../../../../components/ReportCard';

const StyledFormCheck = styled(Form.Check)`
    display: flex !important;
    align-items: center;
    margin-bottom: 0;

    .form-check-input {
        width: 1.25em;
        height: 1.25em;
        margin-right: 0.5em;
        margin-bottom: 0.25em;
    }
`;

const buildHardHitSeries = (plays, islhb) => {
    if (!plays || !plays.length) return [];

    const hits = { data: [],
        name: 'Hard hit',
        index: 1,
        id: 'hit',
        color: '#000',
        marker: { symbol: 'diamond', radius: 4, lineColor: '#000', fillColor: '#000', lineWidth: 2 } };

    for (let i = 0; i < plays.length; ++i) {
        if (plays[i].platex && plays[i].platez) {
            const result = plays[i].resultid;
            const event = plays[i].baseevent;

            const point = {
                x: -plays[i].platex,
                y: plays[i].platez,
                gameid: plays[i].gameid,
                eventseq: plays[i].eventseq,
                pitchseq: plays[i].pitchseq,
            };

            if ((((result === 14 || result === 15) && event > 0 && event < 5 && plays[i].wellhit === true)
                || ((result === 14 || result === 15) && plays[i].wellhit === true && (event === 8 || (event > 10 && event < 16))))
                && plays[i].islhb === islhb) {
                hits.data.push(point);
            }
        }
    }

    return [hits];
};

const HeatMaps = ({ isLoading, heatmaps, repertoire, pitches, isLhb }) => {
    const { t: translate } = useTranslation();

    const [showHardHit, setShowHardHit] = useState(true);

    if (isLoading) return <div className="py-5 text-center"><LoadingSpinner /></div>;

    return (
        <ReportCard title={translate('pitcher-overview.sections.heat-maps')}>
            {pitches.length ? (
                <>
                    <div className="d-flex justify-content-around w-100 flex-wrap">
                        {repertoire.filter((r) => r.pitches / r.pitches_total > 0.08).map((r) => {
                            const heatMap = heatmaps.find((hm) => hm.PitchType === r.fxtype && (hm.FxSubType || 0) === r.fxsubtype && hm.IsLHB === isLhb && hm.Split === 'Distribution2k')
                        || heatmaps.find((hm) => hm.PitchType === r.fxtype && (hm.FxSubType || 0) === r.fxsubtype && hm.IsLHB === isLhb && hm.Split === 'Distribution');
                            if (heatMap) {
                                return (
                                    <div key={`${r.fxtype}-${r.fxsubtype}`}>
                                        <div className="text-center fs-6 mb-2 fw-bold">{pitchTypeDisplayName(r, false, false, translate)}</div>
                                        <StrikeZone
                                            heatMapBackground={`data:${heatMap.ContentType};base64,${heatMap.HeatMapImg}`}
                                            pitcherView={false}
                                            seriesData={showHardHit ? buildHardHitSeries(pitches.filter((x) => x.fxtype === r.fxtype && x.fxsubtype === r.fxsubtype), isLhb) : []}
                                            showlhb={isLhb}
                                            size="ocsheet"
                                            heatMapBackgroundOpacity={1}
                                            hideGrid
                                            hideAxis
                                            // showStrikeZone={false}
                                            pointshrinkcutoff={0}
                                        />
                                    </div>
                                );
                            }
                            return null;
                        }).filter((x) => x)}
                    </div>
                    <div className="d-flex justify-content-center">
                        <StyledFormCheck
                            id="showHardHit"
                            type="checkbox"
                            label={translate('pitcher-overview.heat-maps.show-hard-hit')}
                            checked={showHardHit}
                            onChange={({ target }) => setShowHardHit(target.checked)}
                            className="mt-1 d-print-none"
                        />
                    </div>
                </>
            ) : <div className="d-flex justify-content-center py-5 text-muted">{translate('pitcher-overview.no-data')}</div>}
        </ReportCard>
    );
};

export default HeatMaps;
